import * as React from 'react';

let LOCALES: Record<string, unknown> = {};
let IS_SSR_MODE = false;

export const setLocales = (locales: Record<string, unknown>) => LOCALES = locales;

export const getLocales = () => LOCALES;

export const setSsrMode = (isSsr: boolean) => IS_SSR_MODE = isSsr;

export const getParametrizedText = (text: string, params: { [key: string]: string | number }) => {
	return Object.keys(params)
		.reduce(
			(result: string, key: string) => result.replace(new RegExp(`\{\{${key}\}\}`, 'g'), String(params[key])),
			text,
		);
};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const getTranslation = <T extends unknown>(dir: string): T => {
	const locales = getLocales();

	return IS_SSR_MODE
		? new Proxy(
			{},
			{
				get: (target, name: string) => {
					const currentLocales = getLocales();

					return (currentLocales[dir] as Record<string, string>)?.[name] || '';
				},
			},
		) as T
		: locales[dir] as T;
};

export interface IReactTextInjectedProps {
	text: string;
}

const DEFAULT_COMPONENTS: Record<string, (props: IReactTextInjectedProps) => JSX.Element> = {
	Br: () => <br/>,
};

export const getReactText = (text: string, components: Record<string, (props: IReactTextInjectedProps) => JSX.Element> = {}) => {
	const parts = text
		.split(/(<[^\s\/]+?>.*?<\/[^\s]+?>)/)
		.map((item) => item.split(/(<[^\s]+?\/>)/))
		.flat();

	return (
		<>
			{parts.map((item, index) => {
				const matchedSeparateClosed = item.match(/(<([^\s]+?)>(.*?)<\/[^\s]+?>)/);
				const matchedSelfClosed = item.match(/(<([^\s]+?)\/>)/);
				const matched = matchedSeparateClosed || matchedSelfClosed;

				if (matched) {
					const [,, key, content] = matched;
					const Component = components[key] || DEFAULT_COMPONENTS[key];

					if (!Component) {
						// eslint-disable-next-line no-console
						console.error(`Call getReactText with empty component ${key}`);
					}

					return <Component key={index} text={content}/>;
				} else {
					return item;
				}
			})}
		</>
	);
};
